export const PAYROLL_STATUS = new Map(Object.entries({
  INITIATED: 'INITIATED',
  FINALIZED: 'FINALIZED'
}))